<template>
  <div class="suivi-instantane-page">
    <instant-dashboard />
  </div>
</template>

<script>
import InstantDashboard from '@/components/dashboard/InstantDashboard.vue'

export default {
  name: 'SuiviInstantanePage',
  components: {
    InstantDashboard,
  },
}
</script>

<style lang="scss" scoped>
.suivi-instantane-page {
  padding: 1.5rem;
  min-height: 100vh;
  background: #f8f9fa;
}
</style>
